(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('runner-race-resume', {
            parent: 'entity',
            url: '/runner-race-resume',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.runnerRaceResume.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resumes.html',
                    controller: 'RunnerRaceResumeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('runnerRaceResume');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('runner-race-resume-detail', {
            parent: 'runner-race-resume',
            url: '/runner-race-resume/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.runnerRaceResume.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resume-detail.html',
                    controller: 'RunnerRaceResumeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('runnerRaceResume');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RunnerRaceResume', function($stateParams, RunnerRaceResume) {
                    return RunnerRaceResume.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'runner-race-resume',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('runner-race-resume-detail.edit', {
            parent: 'runner-race-resume-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resume-dialog.html',
                    controller: 'RunnerRaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RunnerRaceResume', function(RunnerRaceResume) {
                            return RunnerRaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('runner-race-resume.new', {
            parent: 'runner-race-resume',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resume-dialog.html',
                    controller: 'RunnerRaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                distance: null,
                                timeTotal: null,
                                paceAVG: null,
                                finishDate: null,
                                startDate: null,
                                calorie: null,
                                runnerPlace: null,
                                raceCompleted: null,
                                mapUrl: null,
                                minimumAchieved: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('runner-race-resume', null, { reload: 'runner-race-resume' });
                }, function() {
                    $state.go('runner-race-resume');
                });
            }]
        })
        .state('runner-race-resume.edit', {
            parent: 'runner-race-resume',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resume-dialog.html',
                    controller: 'RunnerRaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RunnerRaceResume', function(RunnerRaceResume) {
                            return RunnerRaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('runner-race-resume', null, { reload: 'runner-race-resume' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('runner-race-resume.delete', {
            parent: 'runner-race-resume',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner-race-resume/runner-race-resume-delete-dialog.html',
                    controller: 'RunnerRaceResumeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RunnerRaceResume', function(RunnerRaceResume) {
                            return RunnerRaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('runner-race-resume', null, { reload: 'runner-race-resume' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
